import { useMediaApplicationContext } from '@components/MediaApplicationContext';
import useGeneralSettingsStore from '../../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { getMediaAspectRatio } from '../../../../../../../utils/getMediaAspectRatio';

export const useRachelProductCard = (imageUrl?: string | null) => {
  const { getMediaFromSize } = useMediaApplicationContext();
  const mediaFormat = useGeneralSettingsStore((state) => state.generalSettings.mediaFormat);

  return {
    mediaSrc: imageUrl ? getMediaFromSize(imageUrl, 'sm') : undefined,
    aspectRatio: getMediaAspectRatio(mediaFormat),
  };
};
